// Section 3: a neutral name list bundled with the game (no network). Short given names drawn
// from many traditions; the player may rename anyone.
export const names = Object.freeze({
  female: Object.freeze([
    'Ada',
    'Agnes',
    'Aiko',
    'Alba',
    'Alma',
    'Amara',
    'Anja',
    'Anna',
    'Asha',
    'Astrid',
    'Beata',
    'Bela',
    'Berit',
    'Bianca',
    'Brigid',
    'Carmen',
    'Cato',
    'Celia',
    'Clara',
    'Dagny',
    'Dalia',
    'Dana',
    'Delia',
    'Dora',
    'Edda',
    'Edith',
    'Eira',
    'Elena',
    'Elin',
    'Ella',
    'Elsa',
    'Emi',
    'Esme',
    'Eva',
    'Faye',
    'Freya',
    'Gala',
    'Greta',
    'Gwen',
    'Hana',
    'Hedda',
    'Helga',
    'Hilde',
    'Ida',
    'Ilse',
    'Imke',
    'Ines',
    'Iris',
    'Isla',
    'Ivy',
    'Jana',
    'Jora',
    'Julia',
    'Juna',
    'Kaja',
    'Kala',
    'Kara',
    'Keira',
    'Kira',
    'Lana',
    'Lea',
    'Leila',
    'Lena',
    'Lia',
    'Lina',
    'Liv',
    'Lora',
    'Lucia',
    'Luna',
    'Lydia',
    'Mabel',
    'Maia',
    'Mara',
    'Marta',
    'Maya',
    'Mei',
    'Mila',
    'Mira',
    'Nadia',
    'Naomi',
    'Nell',
    'Nia',
    'Nina',
    'Noor',
    'Nora',
    'Oda',
    'Olga',
    'Ona',
    'Orla',
    'Paloma',
    'Petra',
    'Pia',
    'Rafa',
    'Rhea',
    'Rina',
    'Rosa',
    'Runa',
    'Ruth',
    'Saga',
    'Salma',
    'Sana',
    'Sara',
    'Selma',
    'Signe',
    'Sina',
    'Sofia',
    'Solveig',
    'Suki',
    'Svea',
    'Talia',
    'Tamar',
    'Tara',
    'Thea',
    'Tilde',
    'Tova',
    'Una',
    'Uma',
    'Vera',
    'Vesna',
    'Vida',
    'Wanda',
    'Wren',
    'Xenia',
    'Yara',
    'Yuki',
    'Zara',
    'Zelda',
    'Zoe',
    'Ayla',
    'Brit',
    'Cora',
    'Dita',
    'Enid',
    'Fern',
    'Gilda',
    'Hesper',
    'Ione',
    'Jade',
    'Kit',
    'Lotte',
  ]),
  male: Object.freeze([
    'Abel',
    'Adem',
    'Aksel',
    'Alden',
    'Amir',
    'Anders',
    'Arlo',
    'Arne',
    'Aron',
    'Asa',
    'Axel',
    'Bao',
    'Basil',
    'Bede',
    'Bjorn',
    'Bram',
    'Cai',
    'Cato',
    'Cyril',
    'Dag',
    'Dario',
    'Davi',
    'Den',
    'Dmitri',
    'Eamon',
    'Edvin',
    'Einar',
    'Elias',
    'Emil',
    'Enzo',
    'Erik',
    'Ezra',
    'Felix',
    'Finn',
    'Gael',
    'Gideon',
    'Goran',
    'Gunnar',
    'Halvard',
    'Hamid',
    'Hans',
    'Haru',
    'Hugo',
    'Ibrahim',
    'Idris',
    'Igor',
    'Ivan',
    'Jalen',
    'Jarl',
    'Jonas',
    'Jory',
    'Joss',
    'Kai',
    'Kasim',
    'Kenji',
    'Knut',
    'Lars',
    'Leif',
    'Leon',
    'Levi',
    'Linus',
    'Lorn',
    'Luca',
    'Magnus',
    'Malik',
    'Marek',
    'Matti',
    'Milo',
    'Nils',
    'Noah',
    'Odd',
    'Olaf',
    'Omar',
    'Oren',
    'Oskar',
    'Otto',
    'Pavel',
    'Per',
    'Pim',
    'Quinn',
    'Rafael',
    'Ravi',
    'Reid',
    'Rolf',
    'Rune',
    'Sami',
    'Sander',
    'Sebastian',
    'Sergei',
    'Silas',
    'Sten',
    'Sven',
    'Taro',
    'Teo',
    'Thane',
    'Tobias',
    'Tomas',
    'Torin',
    'Ulf',
    'Umar',
    'Uri',
    'Valter',
    'Vidar',
    'Viktor',
    'Wade',
    'Walt',
    'Wim',
    'Yann',
    'Yosef',
    'Yuri',
    'Zane',
    'Zeno',
    'Ansel',
    'Beck',
    'Cass',
    'Dov',
    'Evander',
    'Frode',
    'Gus',
    'Hale',
    'Ilan',
    'Jem',
    'Kell',
    'Lio',
    'Mads',
    'Ned',
    'Orrin',
    'Pell',
    'Rolan',
    'Soren',
    'Tavi',
    'Ulrich',
    'Vale',
    'Wolf',
    'Yves',
    'Zev',
    'Arvid',
    'Brin',
    'Corin',
    'Dane',
  ]),
});
